module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"showFullSizeView":"Full screen","exitFullSizeView":"Fit to screen","close":"Close"},"es":{"showFullSizeView":"Pantalla completa","exitFullSizeView":"Ajustar a la pantalla","close":"Cerrar"}}')
  delete Component.options._Ctor
}
